import { useInteractionDoneTracking } from "@/mixins/tracking/interaction-done";

export const mainMenuProps = () => ({
  categories: {
    type: Array,
    required: true
  },
  activeCategory: {
    type: Object,
    required: false,
    default: null
  },
  showMesRepas: {
    type: Boolean,
    required: false,
    default: false
  },
  boutiqueExcluWebId: {
    type: String,
    required: false,
    default: null
  },
  isHomePage: {
    type: Boolean,
    required: false,
    default: false
  },
  isNational: {
    type: Boolean,
    required: false,
    default: false
  },
  coinDesMarquesIds: {
    type: Array,
    required: false,
    default: () => []
  },
  recettesPushZone: {
    type: Object,
    required: false,
    default: () => { }
  },
  arborescence: {
    type: Array,
    required: false,
    default: () => []
  }
});

export const mainMenuEmits = () => ([
  "hideMenu"
]);

export const useMainMenu = (props, emit, timeoutDelay = 200) => {
  const { trackEvent } = useInteractionDoneTracking();

  const timeout = ref(null);
  const currentItem = ref(null);
  const showIdeeRepas = ref(false);

  const categoriesWithoutHeader = computed(() => {
    return props.categories.filter(categorie => !categorie.attributes.is_header_selections);
  })
  const hasChildren = computed(() => {
    return currentItem.value && currentItem.value.attributes && currentItem.value.attributes.children && currentItem.value.attributes.children.data;
  })

  const setCurrentItem = (item, isClicked = false, isLast = false) => {
    if (isClicked && (item && item.attributes && !item.attributes.children || isLast)) {
      trackNavigation(item);
      navigateToInternal(item.attributes.slug);
      emit('hideMenu');
    }
    else {
      if (timeout.value) {
        clearTimeout(timeout.value);
        timeout.value = null;
      }
      timeout.value = setTimeout(() => {
        showIdeeRepas.value = false;
        currentItem.value = item;
      }, timeoutDelay)
    }
  }


  const onNavigateToMenuItem = (item) => {
    trackNavigation(item);
    emit("hideMenu");
  };

  const trackNavigation = (item) => {
    const arborescence = [...props.arborescence, item ? item.attributes.libelle : undefined];
    trackEvent({
      categoryGA: trackingCodes.CATEGORYGA.menu,
      actionGA: arborescence[0],
      labelGA: arborescence[1],
      click_chapter4: arborescence.length > 3 ? arborescence[2] : null,
      click_text: arborescence.length > 3 ? arborescence[3] : arborescence[2]
    });
  }

  const setIdeeRepas = () => {
    if (timeout.value) {
      clearTimeout(timeout.value);
      timeout.value = null;
    }
    timeout.value = setTimeout(() => {
      currentItem.value = null;
      showIdeeRepas.value = true;
    }, timeoutDelay)
  }


  const clearHoverTimeout = () => {
    clearTimeout(timeout.value);
  }
  return {
    timeout,
    hasChildren,
    currentItem,
    showIdeeRepas,
    categoriesWithoutHeader,
    setCurrentItem,
    setIdeeRepas,
    clearHoverTimeout,
    onNavigateToMenuItem
  }
};
